import React, { useState } from "react";
import { useGet } from "seed/api";
import View from "components/presentation/environments/Environments.view";

function Environments({ flow }) {

  const [isManageOpen, setIsManageOpen] = useState(false);
  const [isMergeOpen, setIsMergeOpen] = useState(false);

  const reqEnvironments = useGet("/flows/environments", { flow_id: flow.id });

  const environments = reqEnvironments.data || [];
  const current = environments.find((item) => item.id == flow.id);

  const onClickEnvironment = (environmentId) => {
    if (environmentId == flow.id) return;
    window.location.href = `/app/?flow_id=${environmentId}`;
  }

  const onChanged = () => {
    setIsManageOpen(false);
    reqEnvironments.refetch();
  }

  // The whole app is scoped to the flow_id in the URL, so deleting the current
  // environment would leave the page pointing at a flow that no longer exists.
  const onDeleted = (environmentId) => {
    if (environmentId != flow.id) {
      onChanged();
      return;
    }
    const root = environments.find((item) => item.is_root);
    window.location.href = `/app/?flow_id=${root.id}`;
  }

  const onClickMerge = () => {
    setIsManageOpen(false);
    setIsMergeOpen(true);
  }

  if (reqEnvironments.loading) return null;

  return (
    <View
      current={current}
      environments={environments}
      flow={flow}
      isManageOpen={isManageOpen}
      isMergeOpen={isMergeOpen}
      isProduction={current?.environment == "PROD"}
      onChanged={onChanged}
      onClickEnvironment={onClickEnvironment}
      onClickManage={() => setIsManageOpen(true)}
      onClickMerge={onClickMerge}
      onCloseManage={() => setIsManageOpen(false)}
      onCloseMerge={() => setIsMergeOpen(false)}
      onDeleted={onDeleted}
    />
  );

}

export default Environments;
